import React, { useState, useEffect } from "react";
import ReactGa from "react-ga";

import { getContentByUrl, hex2rgba } from "./api/Utils";

import Header from "./components/Header";

import "./App.css";

import CorporateHousing from "./components/CorporateHousing";
import FAQ from "./components/FAQ";
import Gallery from "./components/Gallery";
import About from "./components/About";
import Additionals from "./components/Additionals";
import ContactUs from "./components/ContactUs";
import Footer from "./components/Footer";
import NotFound from "./components/NotFound";
import Loader from "./components/Loader";

function App() {
  const [commonData, setCommonData] = useState(null);
  const [clientData, setClientData] = useState(null);
  const [menu, setMenu] = useState([]);
  const [bannerImage, setBannerImage] = useState([]);
  const [gallerydata, setGalleryData] = useState([]);

  function faqToggleClick(e) {
    if (e.target.parentNode.classList.contains("active")) {
      e.target.parentNode.classList.remove("active");
    } else {
      e.target.parentNode.classList.add("active");
    }
  }

  const handleScroll = () => {
    let stickyPosition = document.getElementById("sticky-nav");
    let stickyNav = document.getElementById("navbar");
    let position = stickyPosition.getBoundingClientRect().top;
    if (position <= 50) {
      stickyNav.classList.add("sticky");
    } else {
      stickyNav.classList.remove("sticky");
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      const myclient = "/" + window.location.pathname.split(/(?![-])\W|_/g)[1];
      let commonResult = await getContentByUrl(
        `/corporate-housing/common-data`
      );
      let clientResult = await getContentByUrl(`/corporate-housing${myclient}`);

      commonResult = commonResult?.data;
      clientResult = clientResult?.data;

      setCommonData(commonResult);
      setClientData(clientResult);

      if (clientResult !== null) {
        //setting theme colors for specific clients
        if (
          clientResult?.clientPrimaryColor !== null &&
          clientResult?.clientSecondaryColor !== null
        ) {
          const $style = document.createElement("style");
          document.head.appendChild($style);
          $style.innerHTML = `.purple,.swiper-button-prev,.swiper-button-next,.all-content { color: #${
            clientResult?.clientPrimaryColor?.color
          };}
                              .bgpurple { background: #${
                                clientResult?.clientPrimaryColor?.color
                              };}
                              .banner-text { background: ${hex2rgba(
                                clientResult?.clientPrimaryColor?.color,
                                0.5
                              )};}
                              .navbar { background: ${hex2rgba(
                                clientResult?.clientPrimaryColor?.color,
                                0.9
                              )};}
                              .sticky { background: ${hex2rgba(
                                clientResult?.clientPrimaryColor?.color,
                                1
                              )};}
                              .bggreen { background: #${
                                clientResult?.clientSecondaryColor?.color
                              };}`;
        } else {
          //setting theme colors for defaults
          const $style = document.createElement("style");
          document.head.appendChild($style);
          $style.innerHTML = `.purple,.swiper-button-prev,.swiper-button-next,.all-content { color: #${
            commonResult?.primaryColor?.color
          };}
                              .bgpurple { background: #${
                                commonResult?.primaryColor?.color
                              };}
                              .banner-text { background: ${hex2rgba(
                                commonResult?.primaryColor?.color,
                                0.5
                              )};}
                              .navbar { background: ${hex2rgba(
                                commonResult?.primaryColor?.color,
                                0.9
                              )};}
                              .sticky { background: ${hex2rgba(
                                commonResult?.primaryColor?.color,
                                1
                              )};}
                              .bggreen { background: #${
                                commonResult?.secondaryColor?.color
                              };}`;
        }

        //google tracking ID
        if (clientResult?.googleTrackingID !== "") {
          ReactGa.initialize(clientResult?.googleTrackingID);
          ReactGa.pageview("/");
        } else if (commonResult?.googleTrackingID !== "") {
          ReactGa.initialize(commonResult?.googleTrackingID);
          ReactGa.pageview("/");
        }

        //menu
        if (clientResult?.menuItems?.length > 0) {
          setMenu(clientResult?.menuItems);
        } else {
          setMenu(commonResult?.menuItems);
        }

        //tab title
        document.title = `${commonResult?.commonTabHeading} | ${
          clientResult?.clientTabHeading || ""
        }`;

        clientResult?.clientBannerImage !== null
          ? setBannerImage(clientResult?.clientBannerImage)
          : setBannerImage(commonResult?.bannerImage);

        clientResult?.clientGalleryImage.length !== 0
          ? setGalleryData(clientResult.clientGalleryImage)
          : setGalleryData(commonResult.commonGalleryImage);
      } else {
        setMenu(commonResult?.menuItems);
        setBannerImage(commonResult?.bannerImage);
        setGalleryData(commonResult?.commonGalleryImage);

        //tab title
        document.title = commonResult?.commonTabHeading;

        //setting theme colors for all
        const $style = document.createElement("style");
        document.head.appendChild($style);
        $style.innerHTML = `.purple,.swiper-button-prev,.swiper-button-next,.all-content { color: #${
          commonResult?.primaryColor?.color
        };}
                              .bgpurple { background: #${
                                commonResult?.primaryColor?.color
                              };}
                              .banner-text { background: ${hex2rgba(
                                commonResult?.primaryColor?.color,
                                0.5
                              )};}
                              .navbar { background: ${hex2rgba(
                                commonResult?.primaryColor?.color,
                                0.9
                              )};}
                              .sticky { background: ${hex2rgba(
                                commonResult?.primaryColor?.color,
                                1
                              )};}
                              .bggreen { background: #${
                                commonResult?.secondaryColor?.color
                              };}`;
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div className="main-content">
      {/* {document.readyState === 'complete' 
      ? */}
      {commonData !== null ? (
        clientData !== null ? (
          <div className="all-content" id="topContent">
            <Header
              commonData={commonData}
              clientData={clientData}
              menu={menu}
              bannerImage={bannerImage}
            />

            {clientData.includeCorporate ? (
              <CorporateHousing
                commonData={commonData}
                clientData={clientData}
              />
            ) : (
              ""
            )}

            <FAQ
              commonData={commonData}
              clientData={clientData}
              faqToggleClick={faqToggleClick}
            />

            {clientData.includeGallery ? (
              <Gallery
                commonData={commonData}
                clientData={clientData}
                gallerydata={gallerydata}
              />
            ) : (
              ""
            )}

            {clientData.includeAboutDwellworks ? (
              <About commonData={commonData} />
            ):(
              ""
            )}

            {clientData.addNewSection &&
            clientData.addNewSection.length !== 0 ? (
              <Additionals clientData={clientData} />
            ) : (
              ""
            )}

            <ContactUs 
              commonData={commonData} 
              clientData={clientData} 
            />
            <Footer 
              commonData={commonData} 
              clientData={clientData} 
              menu={menu}
            />
          </div>
        ) : (
          <NotFound />
        )
      ) : (
        <Loader />
      )}
    </div>
  );
}

export default App;
